export const servicesTranslationKeys = ['transfers_banner.door_to_door_service', 'transfers_banner.no_luggage_hassle']